import React, { useEffect, useMemo, useState } from 'react';

import * as S from './styles';
import {
  KenloSignatureTextIcon,
  MailCircleSignature,
  PersonCircle,
  DocumentsAssignSignatureIcon,
  ContractCardIcon,
  Gift,
} from 'components/Icons';

import { Close } from 'styled-icons/ionicons-outline';
import { Line } from 'components/Line';
import { ArrowSync } from 'styled-icons/fluentui-system-regular';
import NumberInputComponent from 'pages/KenloSignature/Drawer/components/NumberInputComponent';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { Switch } from 'components/switch/Switch';
import { Modal } from 'components/Modal/Modal';
import { api } from 'services/api';
import { customRoundCurrency } from 'pages/KenloSignature';
interface IBuy {
  closeDrawer: () => void;
  setDrawerOption: () => void;
  idInternalProduct?:number
}
const observation = [
  {
    icon: <DocumentsAssignSignatureIcon />,
    text: (
      <S.Subtitle>
        Os documentos e contratos são
        <S.SubtitleBold>assinados com segurança </S.SubtitleBold> em parceria
        com a<S.SubtitleBold> CertiSign. </S.SubtitleBold>
      </S.Subtitle>
    ),
  },
  {
    icon: <ContractCardIcon />,
    text: (
      <S.Subtitle>
        Assinaturas autenticadas com
        <S.SubtitleBold>prova de vida </S.SubtitleBold>consomem um{' '}
        <S.SubtitleBold>
          envelope adicional por envio realizado.{' '}
        </S.SubtitleBold>
      </S.Subtitle>
    ),
  },
  {
    icon: <ArrowSync size={24} color="#298EE6" />,
    text: (
      <S.Subtitle>
        A franquia adicional
        <S.SubtitleBold> não é renovada automaticamente,</S.SubtitleBold>
        mas sempre que precisar você poderá contratar mais créditos.
      </S.Subtitle>
    ),
  },
  {
    icon: <PersonCircle />,
    text: (
      <S.Subtitle>
        Acesse os boletos e visualize o histórico dos créditos através da
        <S.SubtitleBold>&nbsp;área do cliente.</S.SubtitleBold>
      </S.Subtitle>
    ),
  },
];
const Buy = ({ closeDrawer, setDrawerOption, idInternalProduct }: IBuy) => {
  const [quantity, setQuantity] = useState(5);
  const [useExceedingEnvelopes, setUseExceedingEnvelopes] = useState(false);
  const [frequency,setFrequency] = useState<"mensal" | "anual">("mensal")
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [productPrice,setProductPrice] = useState<any>({});
  const [products,setProducts] = useState<any[]>([]);
  const [aceptTerms, setAceptTerms] = useState(false)
  const Contract = async () => {
    const accessToken = localStorage.getItem('accessToken');
    const idToken = localStorage.getItem('idToken');
    const idProduct  = products[0].id_product
    try {
     await api.post(
        `case`,
        {
          useNegative: useExceedingEnvelopes,
          frequency,
          type: "novo",
          products: [
            {
            id_product: idProduct,
            quantity: quantity
            }
          ],
          log: {
            id_log_type: 1,
            title: 'Solicitou a contratação do Kenlo Assinaturas',
            description: `${quantity} envelopes no valor de ${
              customRoundCurrency((productPrice.cost * quantity) - (productPrice.cost * quantity * discount/100))
            } por mês.`
          },
        },
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      setDrawerOption();
    } catch (error) {
      setIsOpenModal(true);
    }
  };
  useEffect(() => {
    const fetchDataProducts = async () => {
      const accessToken = localStorage.getItem('accessToken');
      const idToken = localStorage.getItem('idToken');
      try {
        const { data } = await api.get(
          `external-products/${idInternalProduct}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setProducts(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchDataProducts();
  }, [idInternalProduct]);
  useEffect(() => {
    const fetchDataPrices = async () => {
      const accessToken = localStorage.getItem('accessToken');
      const idToken = localStorage.getItem('idToken');
      try {
        const idProduct  = products[0].id_product
        const { data } = await api.get(
          `external-products/prices/?id_product=${idProduct}&frequency=${frequency}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        setProductPrice(data.data);
      } catch (error) {
        console.log(error);
      }
    };
    
    products[0] && fetchDataPrices();
  }, [products, frequency]);
  const discount = useMemo(()=>{
    const discounts = productPrice?.discounts;
    if (!Array.isArray(discounts) || discounts.length === 0) return 0;

    const applicable = discounts
      .filter((d: any) => typeof d?.min_quantity === 'number' && typeof d?.perc_discount === 'number' && quantity >= d.min_quantity)
      .sort((a: any, b: any) => b.min_quantity - a.min_quantity);

    if (applicable.length === 0) return 0;
    return applicable[0].perc_discount;
  },[productPrice?.discounts, quantity])
  return (
    <>
      <S.Header>
        <S.Infos>
          <S.Profile>
            <KenloSignatureTextIcon />
          </S.Profile>

          <S.Close onClick={closeDrawer}>
            <Close size={24} />
          </S.Close>
        </S.Infos>

        <S.Infos>
          <S.Subtitle>
            Personalize seu plano mensal e confira os valores e condições.
          </S.Subtitle>
        </S.Infos>
      </S.Header>
      <S.Main>
        <S.Box>
          <S.BoxContent>
            <S.Form>
              <S.Subtitle>Selecione seu plano</S.Subtitle>
              <S.Toggle>
                <S.ToggleItem active={frequency === "anual"} onClick={()=>setFrequency("anual")}>Anual</S.ToggleItem>
                <S.ToggleItem active={frequency === "mensal"} onClick={()=>setFrequency("mensal")}>Mensal</S.ToggleItem>
              </S.Toggle>
            </S.Form>
            <S.Form>
              <S.Subtitle>
                <MailCircleSignature />
                <S.SubtitleBold>&nbsp;&nbsp;Envelopes</S.SubtitleBold>
              </S.Subtitle>
              <NumberInputComponent
                value={quantity}
                onChange={(newValue) => setQuantity(newValue)}
                min={1}
                max={20000}
              />
            </S.Form>
            <Line width="100%" border="0.1rem" />

            <S.BoxFooter>
              {discount > 0 ?     <InvoiceStatus
                status={'kenloSignatureGift'}
                text={`${discount}% de desconto`}
                icon={<Gift color="white" />}
                fontWeight="500"
                colortText="white"
              /> : <div></div>}
  
              <S.ContentFooter>
                <S.TitleValue>Pagamento no boleto</S.TitleValue>
                <S.Value>{customRoundCurrency(productPrice?.cost ? (productPrice.cost * quantity) - (productPrice.cost * quantity * discount/100) : 0)}</S.Value>
              </S.ContentFooter>
            </S.BoxFooter>
          </S.BoxContent>
        </S.Box>
        <S.Box>
          <S.BoxContent>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '16px',
                justifyContent: 'space-between',
              }}
            >
              <S.SubtitleBold>Usar envelopes pós-pago</S.SubtitleBold>
              <Switch
                checked={useExceedingEnvelopes}
                onChange={() =>
                  setUseExceedingEnvelopes(!useExceedingEnvelopes)
                }
              />
            </div>
            <S.TextInfos lineWeight="500">
              Caso o saldo do plano acabe, será possível continuar utilizando
              envelopes pós-pago com acréscimo de 30% no valor. Essa
              configuração pode ser alterada depois.
            </S.TextInfos>
          </S.BoxContent>
        </S.Box>
        <S.Box>
          <S.BoxContent>
            <S.SubtitleBold>Observações</S.SubtitleBold>
            {observation.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  gap: '16px',
                  alignItems: 'center',
                  marginTop: '16px',
                }}
              >
                <div>{item.icon}</div>
                <div>{item.text}</div>
              </div>
            ))}
          </S.BoxContent>
        </S.Box>
        <S.TextInfos lineWeight="500">
          <S.Checkbox type="checkbox" id="terms" name="terms" required onClick={()=> setAceptTerms(!aceptTerms)}/>
          Ver{' '}
          <S.TextInfos color="#F82E52" style={{ cursor: 'pointer' }}>
            termos de serviço
          </S.TextInfos>{' '}
          do kenlo Assinaturas.
        </S.TextInfos>
      </S.Main>
      <S.DrawerFooter>
        <S.CustomButton variant="link"> Cancelar</S.CustomButton>
        <S.CustomButton variant="primary"  disabled={!aceptTerms} onClick={Contract}>
          Contratar
        </S.CustomButton>
      </S.DrawerFooter>
      {isOpenModal && (
        <Modal
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          title="Não é possível contratar agora"
          closeText="Abrir chat"
          successText="Fechar"
          onSuccess={() => {
            setIsOpenModal(false);
          }}
        >
          <S.TextInfos lineWeight="500">
            Já existe uma solicitação de contratação desse produto em andamento.
            Aguarde a finalização ou fale com nosso time se a solicitação
            estiver demorando mais do que o esperado.
          </S.TextInfos>
        </Modal>
      )}
    </>
  );
};
export default Buy;
